(function () {
    'use strict';

    angular.module('app.dailySetup', [
        'app.core',
        'app.widgets'
        ,'react'
    ]);
})();
